// extracted by mini-css-extract-plugin
export default {"form-group":"historyLog_form-group__UzPhT bootstrap_form-group__jv10u","row":"historyLog_row__FzJPS bootstrap_row__t0Hu5"};